import type { Resource } from '../../';
export const forms_error_validPhoneNumber: Resource = {"default":"A valid {name} is required."};
